export default __webpack_public_path__ + "static/media/E-commerceRealCase1-moblie-en.6011f316.jpg";